<template>
  <div class="progress-bar">
    <div class="progress-bar__progress" :style="`width: ${getCurrentAmount}%`">
      <transition name="component-fade">
        <ICountUp
          class="progress-bar__status boxshadow-soft"
          :endVal="getCurrentAmount"
          :options="options"
          ref="counter"
          v-show="showCounter"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import { viewOrder } from "./../mixins/settings";
import ICountUp from "vue-countup-v2";

export default {
  mixins: [viewOrder],
  components: {
    ICountUp
  },
  data() {
    return {
      mounted: false,
      showCounter: true,
      startVal: 0,
      endVal: 0,
      options: {
        useEasing: true,
        useGrouping: false,
        suffix: "%"
      }
    };
  },
  watch: {
    getCurrentAmount(newValue) {
      this.$refs.counter.update(this.newValue);

      if (newValue == 100) {
        setTimeout(() => {
          this.showCounter = false;
        }, 800);
      } else {
        this.showCounter = true;
      }
    }
  },
  computed: {
    getCurrentAmount() {
      let amount = 0;
      if (this.mounted) {
        let routeName = this.$route.name;
        let count = Object.keys(viewOrder).length;
        amount = Math.round((100 / count) * viewOrder[routeName]);
      }
      return amount;
    }
  },
  mounted() {
    this.mounted = true;
  }
};
</script>
